import { captureException } from '@sentry/nextjs';
import axios from 'axios';
import { MutationFunction, useMutation } from 'react-query';

import { BUDDY_THE_BOT_URL, isQA } from '~/constants';

type NameWarriorParams = {
  id: number | string;
  names: string[];
  token: string;
};
const stage = isQA ? 'qa' : 'production';

const nameWarrior: MutationFunction<any, any> = async ({
  id,
  names,
  token,
}: NameWarriorParams) => {
  const apiHost = process.env.NEXT_PUBLIC_API_HOST;
  const payload = { names: names };
  const { data } = await axios({
    url: `${apiHost}/warriors/${id}/enshrine`,
    method: 'post',
    data: payload,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  // trigger buddy the bot discord name
  await axios
    .get(`${BUDDY_THE_BOT_URL}/announce-name?nftId=${id}&env=${stage}`)
    .catch((error) => {
      console.log(error);
      captureException(error);
    });
  return { name: data.warrior.name };
};

export const useNameWarrior = () => {
  return useMutation(nameWarrior, {
    retry: 1,
  });
};
